<template>
  <div v-if="mounted">
    <b-row>
      <b-col>
        <b-alert :show="showError" variant="danger">
          <strong>Uwaga.</strong> Problem z połączeniem. Spróbuj ponownie później.
        </b-alert>
      </b-col>
    </b-row>
    <template v-if="['point', 'linestring', 'polygon'].indexOf(geometry) !== -1">
      <div class="form-group row">
          <label for="service" class="control-label col-form-label" :class="{ 'col-sm-2': componentSize === 'sm', 'col-sm-3': componentSize === 'lg'}">Typ wizualizacji</label>
          <div :class="{ 'col-sm-6': componentSize === 'sm', 'col-sm-9': componentSize === 'lg'}">
              <select class="form-control" v-model="selectedVisualizationType" @change="changeStyle">
                  <option v-for="visualizationType in visualizationTypes" :value="visualizationType.value" :key="visualizationType.value">
                      {{ visualizationType.text }}
                  </option>
              </select>                   
          </div>
      </div>
      <template v-if="geometry === 'point'">
          <form-layer-style-point v-bind:visualizationType="selectedVisualizationType" v-bind:attributes="attributes" v-bind:layer-id="layerId" v-bind:size="componentSize" @updated="updateValue" @errorMessage="setError" :icon-picker-type="iconPickerType" ref="layerStylePoint" />
      </template>
      <template v-else-if="geometry === 'linestring'">
        <form-layer-style-line v-bind:visualizationType="selectedVisualizationType" v-bind:attributes="attributes" v-bind:layer-id="layerId" v-bind:size="componentSize" @updated="updateValue" @errorMessage="setError" ref="layerStyleLine" />
      </template>
      <template v-else-if="geometry === 'polygon'">
        <form-layer-style-polygon v-bind:visualizationType="selectedVisualizationType" v-bind:attributes="attributes" v-bind:layer-id="layerId" v-bind:size="componentSize" @updated="updateValue" @errorMessage="setError" ref="layerStylePolygon" />
      </template>
    </template>
    <template v-else-if="geometry === 'geometry'">
      <div class="form-group row">
        <label for="service" class="control-label col-form-label" :class="{ 'col-sm-2': componentSize === 'sm', 'col-sm-3': componentSize === 'lg'}">Typ geometrii</label>
        <div :class="{ 'col-sm-6': componentSize === 'sm', 'col-sm-9': componentSize === 'lg'}">
            <select class="form-control" v-model="selectedGeometryType">
                <option v-for="geometryType in geometryTypes" :value="geometryType.value" :key="geometryType.value.type">
                    {{ geometryType.text }}
                </option>
            </select>                   
        </div>
      </div>
      <div class="form-group row">
          <label for="service" class="control-label col-form-label" :class="{ 'col-sm-2': componentSize === 'sm', 'col-sm-3': componentSize === 'lg'}">Typ wizualizacji</label>
          <div :class="{ 'col-sm-6': componentSize === 'sm', 'col-sm-9': componentSize === 'lg'}">
              <select class="form-control" v-model="selectedVisualizationType" @input="changeStyle">
                  <option v-for="visualizationType in visualizationTypes" :value="visualizationType.value" :key="visualizationType.value">
                      {{ visualizationType.text }}
                  </option>
              </select>                   
          </div>
      </div>
      <form-layer-style-point v-bind:visualizationType="selectedVisualizationType" v-bind:attributes="attributes" v-bind:layer-id="layerId" v-bind:size="componentSize" @updated="updateValue" @errorMessage="setError" v-show="selectedGeometryType === 'point'" :icon-picker-type="iconPickerType" ref="layerStylePoint" />
      <form-layer-style-line v-bind:visualizationType="selectedVisualizationType" v-bind:attributes="attributes" v-bind:layer-id="layerId" v-bind:size="componentSize" @updated="updateValue" @errorMessage="setError" v-show="selectedGeometryType === 'linestring'" ref="layerStyleLine" />
      <form-layer-style-polygon v-bind:visualizationType="selectedVisualizationType" v-bind:attributes="attributes" v-bind:layer-id="layerId" v-bind:size="componentSize" @updated="updateValue" @errorMessage="setError" v-show="selectedGeometryType === 'polygon'" ref="layerStylePolygon" />
    </template>
  </div>
</template>

<script>
import FormLayerStylePoint from "./FormLayerStylePoint.vue";
import FormLayerStyleLine from "./FormLayerStyleLine";
import FormLayerStylePolygon from "./FormLayerStylePolygon";
import LayerStyleStore from "./store/LayerStyleStore";
import VueScrollTo from 'vue-scrollto';

export default {
  name: "FormLayerStyle",
  props: {
    geometry: String,
    attributes: Array,
    layerId: String,
    value: Object,
    size: String,
    iconPickerType: String
  },
  data () {
    return {
      selectedVisualizationType: 'pojedynczy',
      visualizationTypes: [
            { text: "Symbol pojedynczy", value: 'pojedynczy' },
            { text: "Wartość unikalna", value: 'unikalny' },
            { text: "Symbol stopniowy", value: 'stopniowy' }
      ],
      selectedGeometryType: 'point',
      geometryTypes: [
        { text: 'Punktowy', value: 'point' },
        { text: 'Liniowy', value: 'linestring' },
        { text: 'Powierzchniowy', value: 'polygon' }
      ],
      styleLine: {},
      stylePolygon: {},
      default: false,
      styleId: null,
      layerIdBuff: null,
      mounted: false,
      showError: false,
      errorMessage: null,
      validateInProgress: false
    }
  },
  mounted() {
    let store = new LayerStyleStore();
    let style = store.getStyle();
    if(style != null){
      if(style.typ != null){
        this.selectedVisualizationType = style.typ;
        let styleValue = {};
        if(style.reguly != null){
          styleValue.reguly = style.reguly;
        }
        styleValue.id = this.styleId = style.id;
        styleValue.domyslny = this.default = style.domyslny;
        styleValue.layerId = this.layerIdBuff = style.id_warstwy;
        switch(this.geometry){
          case 'point':
            store.setPointStyle(styleValue);
          break;
          case 'linestring':
            store.setLineStyle(styleValue);
          break;
          case 'polygon':
            store.setPolygonStyle(styleValue);
          break;
          case 'geometry':
            let stylePoint = JSON.parse(JSON.stringify(styleValue));
            stylePoint.reguly = stylePoint.reguly.filter(x => x.geometria === "point");
            store.setPointStyle(stylePoint);
            let styleLine = JSON.parse(JSON.stringify(styleValue));
            styleLine.reguly = styleLine.reguly.filter(x => x.geometria === "linestring");
            store.setLineStyle(styleLine);
            let stylePolygon = JSON.parse(JSON.stringify(styleValue));
            stylePolygon.reguly = stylePolygon.reguly.filter(x => x.geometria === "polygon");
            store.setPolygonStyle(stylePolygon);
          break;
        }
      }
    }
    this.mounted = true;
  },
  watch:{
    showError:function(value) {
        if(value){
          VueScrollTo.scrollTo({container:'body',easing: "ease"});
        }
      }
  },
  methods: {
    updateValue() {
      if(!this.validateInProgress) {
        let emitValue = null;
        let store = new LayerStyleStore();
        switch(this.geometry){
          case 'point':
            emitValue = store.getPointStyle();
          break;
          case 'linestring':
            emitValue = store.getLineStyle();
          break;
          case 'polygon':
            emitValue = store.getPolygonStyle();
          break;
          case 'geometry':
            emitValue = {
              reguly: []
            };
            emitValue.reguly.push.apply(emitValue.reguly, store.getPointStyle().reguly);
            emitValue.reguly.filter(x => x.geometria === undefined).forEach(x => x.geometria = "point");
            emitValue.reguly.push.apply(emitValue.reguly, store.getLineStyle().reguly);
            emitValue.reguly.filter(x => x.geometria === undefined).forEach(x => x.geometria = "linestring");
            emitValue.reguly.push.apply(emitValue.reguly, store.getPolygonStyle().reguly);
            emitValue.reguly.filter(x => x.geometria === undefined).forEach(x => x.geometria = "polygon");
          break;
        }
        emitValue.domyslny = this.default !== null ? this.default : undefined;
        emitValue.id = this.styleId !== null ? this.styleId : undefined;
        emitValue.id_warstwy = this.layerIdBuff !== undefined && this.layerIdBuff !== null ? this.layerIdBuff : 
                                (this.styleId !== undefined && this.styleId !== null ? this.styleId : undefined);
        emitValue.typ = this.selectedVisualizationType;
        store.setStyle(emitValue);
        this.$emit('updated');
      }
    },
    changeStyle() {
      let store = new LayerStyleStore();
      store.clear();
    },
    validate() {
      this.errorMessage = null;
      switch(this.geometry){
        case 'point':
          return this.$refs.layerStylePoint.validate();
        case 'linestring':
          return this.$refs.layerStyleLine.validate();
        case 'polygon':
          return this.$refs.layerStylePolygon.validate();
        case 'geometry':
          let validate = false;
          this.validateInProgress = true;
          validate = this.$refs.layerStylePoint.validate();
          validate = this.$refs.layerStyleLine.validate() || validate;
          this.validateInProgress = false;
          validate = this.$refs.layerStylePolygon.validate() || validate;
          return validate;
        break;
      }
    },
    getStyle(){
      let store = new LayerStyleStore();
      return store.getStyle();
    },
    clearStyle(){
      let store = new LayerStyleStore();
      store.clear();
    },
    setError(args) {
      this.showError = args.show;
      this.errorMessage = args.errorMessage;
    }
  },
  computed : {
    componentSize() {
        return this.size == null ? 'sm' : this.size;
    }
  },
  components: {
    FormLayerStylePoint,
    FormLayerStyleLine,
    FormLayerStylePolygon,
    VueScrollTo
  }
}
</script>
